<template>
  <v-row>
    <v-col>
      <v-row align="center" justify="center">
        <v-col align="left">
          <label style="font-weight: 600; font-size: 24px">Objetivo</label>
          <br />
          <p>
            Este aplicativo tem por objetivo gerar os registros E113 para o SPED
            Fiscal ICMS/IPI para empresas do estado de Pernambuco.
          </p>
          <label style="font-weight: 600; font-size: 24px"
            >Como funciona?</label
          >
          <br />
          <p>
            Para gerar os registros E113 o aplicativo reúne as informações do
            arquivo SPED Fiscal do mês anterior ao mês que se deseja gerar os
            registros.
          </p>
        </v-col>
      </v-row>
      <v-file-input
        @change="onFile1"
        counter
        accept="text/plain"
        label="Arquivo SPED Fiscal Mês Anterior"
      />
      <v-file-input
        @change="onFile2"
        counter
        accept="text/plain"
        label="Arquivo SPED Fiscal"
      />
      <v-row align="center" justify="center">
        <v-col>
          <v-text-field
            label="Percentual"
            prepend-icon="mdi-file-percent"
            v-model.lazy="percentual"
            v-money="format"
          />
          <v-checkbox
            hide-details
            v-model="produtos"
            label="Incluir produtos"
            class="mt-0"
          ></v-checkbox>
        </v-col>
        <v-col align="right">
          <v-text-field
            label="Chave de Processamento"
            placeholder="r5HG9i"
            prepend-icon="mdi-key-variant"
            v-model="chave"
          />
          <v-btn small depressed class="green" @click="licencas"
            >Comprar Chave de Processamento</v-btn
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col align="left"></v-col>
        <v-col align="end">
          <v-btn
            depressed
            class="primary"
            @click="processar"
            :disabled="!file1 || !file2 || percentual < 0.1 || !chave.trim()"
            >Processar</v-btn
          >
        </v-col>
      </v-row>
    </v-col>

    <v-dialog v-model="dialog" max-width="360">
      <v-card>
        <v-card-title class="headline">Alguma coisa deu errado...</v-card-title>

        <v-card-text align="justify">{{ errorMessage }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="loading" persistent max-width="360">
      <v-card>
        <v-card-title class="headline">Aguarde...</v-card-title>

        <v-card-text>
          <v-progress-linear indeterminate color="yellow darken-2" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="licenca" max-width="900">
      <v-card>
        <v-card-title class="headline"
          >Comprar Chave de Processamento</v-card-title
        >

        <v-card-text>
          <v-row>
            <v-col align="center">
              <v-select
                :items="listaLicencas.map((item) => item.label)"
                label="Para quantos CNPJs?"
                placeholder="Selecione a quantidade"
                @change="onSelect"
              ></v-select>
              <h2>{{ licencaSelecionada.valor }}</h2>
              <br />
              <p style="color: orange; font-weight: 600">
                A chave de processamento é válida por 6 meses!
              </p>
              <p>
                Após o pagamento envie o comprovante pelo
                <span style="color: lime">WhatsApp</span> para
                <span style="color: gold">(81)99936-2516</span> ou
                <span style="color: gold">anron@hotmail.com</span> para receber
                a chave de processamento.
              </p>
              <p style="color: darkorange; font-weight: 300">
                Após receber a sua chave de processamento, guarde-a em local
                seguro, não compartilhe com ninguém!
              </p>
            </v-col>
            <v-col v-if="licencaSelecionada.valor" align="center">
              <a :href="licencaSelecionada.url">
                <v-img
                  :src="licencaSelecionada.qrcode"
                  style="max-width: 240px"
                />
                <v-img src="../assets/nubank.png" style="max-width: 240px" />
              </a>

              <label>
                <small
                  >Use a câmera do seu celular para ler o link de pagamento ou
                  clique sobre o QRCode.</small
                >
                <br />
                <small
                  >Use seu cartão Nubank para pagar, evite pagar a taxa de
                  transferência!</small
                >
              </label>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { VMoney } from "v-money";

export default {
  data: () => ({
    file1: null,
    file2: null,
    percentual: "6,50",
    chave: "",
    dialog: false,
    errorMessage: "",
    loading: false,
    produtos: true,
    licenca: false,
    listaLicencas: [
      {
        label: "1 - CNPJ",
        valor: "R$ 50,00",
        qrcode: require("../assets/qrcode1.png"),
        url: "https://nubank.com.br/pagar/sl4vb/4lZYatj5L1",
      },
      {
        label: "2 - CNPJs",
        valor: "R$ 100,00",
        qrcode: require("../assets/qrcode2.png"),
        url: "https://nubank.com.br/pagar/sl4vb/Xw871oNFK7",
      },
      {
        label: "3 - CNPJs",
        valor: "R$ 150,00",
        qrcode: require("../assets/qrcode3.png"),
        url: "https://nubank.com.br/pagar/sl4vb/v0Kf70MumS",
      },
      {
        label: "4 - CNPJs",
        valor: "R$ 200,00",
        qrcode: require("../assets/qrcode4.png"),
        url: "https://nubank.com.br/pagar/sl4vb/oXHSNCSpA6",
      },
      {
        label: "5 - CNPJs",
        valor: "R$ 250,00",
        qrcode: require("../assets/qrcode5.png"),
        url: "https://nubank.com.br/pagar/sl4vb/1iEJ7thV9b",
      },
      {
        label: "6 - CNPJs",
        valor: "R$ 300,00",
        qrcode: require("../assets/qrcode6.png"),
        url: "https://nubank.com.br/pagar/sl4vb/6L8cM1meUw",
      },
      {
        label: "7 - CNPJs",
        valor: "R$ 350,00",
        qrcode: require("../assets/qrcode7.png"),
        url: "https://nubank.com.br/pagar/sl4vb/3qjaxSxy8k",
      },
      {
        label: "8 - CNPJs",
        valor: "R$ 400,00",
        qrcode: require("../assets/qrcode8.png"),
        url: "https://nubank.com.br/pagar/sl4vb/jOs44PBPEo",
      },
      {
        label: "9 - CNPJs",
        valor: "R$ 450,00",
        qrcode: require("../assets/qrcode9.png"),
        url: "https://nubank.com.br/pagar/sl4vb/MUi4Mug2Rm",
      },
      {
        label: "10 - CNPJs",
        valor: "R$ 500,00",
        qrcode: require("../assets/qrcode10.png"),
        url: "https://nubank.com.br/pagar/sl4vb/LyIOnJGv3m",
      },
    ],
    licencaSelecionada: {
      label: "",
      valor: "",
      qrcode: "",
      url: "",
    },
    format: {
      decimal: ",",
      thousands: ".",
      prefix: "",
      suffix: " %",
      precision: 2,
      masked: false,
    },
  }),
  directives: { money: VMoney },
  methods: {
    processar() {
      this.loading = true;
      var formdata = new FormData();
      formdata.append("files", this.file1, this.file1.name);
      formdata.append("files", this.file2, this.file2.name);
      formdata.append("percentual", this.percentual);
      formdata.append("chave", this.chave.trim());
      formdata.append("produtos", this.produtos);

      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      // fetch("http://localhost:5000/processar", requestOptions)
      fetch("https://app.anronsoftware.com.br/processar", requestOptions)
        .then((response) => {
          if (response.status === 200) {
            return response.blob();
          } else {
            response.json().then((data) => {
              this.loading = false;
              this.errorMessage = data.message;
              this.dialog = true;
            });
            return null;
          }
        })
        .then((blob) => {
          if (blob) {
            var url = window.URL.createObjectURL(blob);
            var a = document.createElement("a");
            a.href = url;
            a.download = this.file2.name
              .toUpperCase()
              .replace(".txt", "-E113.txt");
            document.body.appendChild(a);
            a.click();
            a.remove();
          }
          this.loading = false;
        });
    },
    onFile1(file) {
      if (file) {
        this.file1 = file;
      } else {
        this.file1 = null;
      }
    },
    onFile2(file) {
      if (file) {
        this.file2 = file;
      } else {
        this.file2 = null;
      }
    },
    licencas() {
      this.licenca = !this.licenca;
    },
    onSelect(value) {
      if (value) {
        const idx = parseInt(value.split(" - ")[0], 10) - 1;
        this.licencaSelecionada = this.listaLicencas[idx];
      } else {
        this.licencaSelecionada = { valor: "", label: "", qrcode: "", url: "" };
      }
    },
  },
};
</script>